import { Pipe, PipeTransform } from '@angular/core';

/**
 * Capitalizes the first letter of the string and the first letter of every
 * sentence that follows a sentence-ending punctuation (`.`, `!`, `?`),
 * regardless of whether there is whitespace after it (so both `. text` and
 * `.text` are handled). All other characters are preserved as-is so that
 * acronyms, drug names (e.g. `EPINEPHrine`), units (`PaO2`, `CO2`), and
 * mixed-case tokens are not destroyed. Decimal numbers like `3.14` are
 * unaffected because only lowercase letters trigger the replacement.
 */
@Pipe({
  name: 'umcSentenceCase',
})
export class UmcSentenceCasePipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) {
      return '';
    }
    return value.replace(/(^|[.!?]\s*)([a-z])/g, (_match, prefix, letter) => {
      return `${prefix}${letter ? letter.toUpperCase() : ''}`;
    });
  }
}
